export default [
  {
    path: '/pix',
    name: 'AllPix',
    component: () => import("@/_backoffice/_financial/components/pix/AllPix.vue"),
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive']
    },
    children:[
      {
        path: 'new_pix',
        name: 'CreatePix',
        component: () => import("@/_backoffice/_financial/components/pix/CreatePix.vue"),
        meta: {
          auth: true,
          roles: ['Director', 'SalesExecutive']
        },
      },
    ]
  },
]